import { tv } from "tailwind-variants";

import { useAmazonChat } from "@/shared/lib/amazon-connect";
import { useSettingsStore } from "@/shared/stores";
import { Button, ChatLineIcon, CloseIcon } from "@/shared/ui";

const styles = tv({
  base: "fixed right-6 bottom-3 z-50 rounded-full p-2 sm:p-4 [&>svg]:size-6",
  variants: {
    isOpen: {
      true: "-translate-y-[500px] sm:-translate-x-76 sm:translate-y-0",
    },
  },
});

export const AmazonChatButton = () => {
  const isOpen = useSettingsStore((state) => state.isAmazonChatOpen);

  const {
    actions: { toggleChatVisibility: toggleChat },
  } = useAmazonChat();

  return (
    <Button
      id="launch-widget-btn"
      size="lg"
      onClick={toggleChat}
      className={styles({ isOpen })}
    >
      {isOpen ? <CloseIcon /> : <ChatLineIcon />}
    </Button>
  );
};
